<template>
  <section class="sale-customers-toolbar app-filter-toolbar">
    <div class="toolbar-main-row app-filter-toolbar-row">
      <div class="search-wrap app-filter-search-wrap">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input
          v-model="searchModel"
          type="text"
          :placeholder="text.detail.customersTab.toolbar.searchPlaceholder"
        />
      </div>

      <div class="toolbar-right app-filter-toolbar-right">
        <multiselect
          v-model="plansFilterModel"
          :options="plansFilterOptions"
          track-by="value"
          label="label"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="false"
          :show-labels="false"
          :searchable="false"
          :allow-empty="false"
          :max-height="220"
          class="sale-customers-plans-inline app-filter-inline-select app-filter-select app-select app-select--filters"
        >
          <template #singleLabel="{ option }">
            <span>{{ text.detail.customersTab.toolbar.plansPrefix }} {{ option?.label || text.detail.customersTab.toolbar.plansFilter.all }}</span>
          </template>
          <template #noResult>
            <span>{{ text.detail.customersTab.toolbar.noOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.detail.customersTab.toolbar.noOption }}</span>
          </template>
        </multiselect>
      </div>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('sales');

export default {
  name: 'SaleCustomersToolbar',
  props: {
    search: {
      type: String,
      default: '',
    },
    plansFilter: {
      type: String,
      default: 'all',
    },
  },
  emits: ['update:search', 'update:plansFilter'],
  data() {
    return {
      text,
      plansFilterOptions: [
        { value: 'all', label: text.detail.customersTab.toolbar.plansFilter.all },
        { value: 'with', label: text.detail.customersTab.toolbar.plansFilter.with },
        { value: 'without', label: text.detail.customersTab.toolbar.plansFilter.without },
      ],
    };
  },
  computed: {
    searchModel: {
      get() {
        return String(this.search || '');
      },
      set(value) {
        this.$emit('update:search', String(value || ''));
      },
    },
    plansFilterModel: {
      get() {
        const current = String(this.plansFilter || 'all');
        return this.plansFilterOptions.find((option) => option.value === current)
          || this.plansFilterOptions[0];
      },
      set(value) {
        this.$emit('update:plansFilter', String(value?.value || 'all'));
      },
    },
  },
};
</script>

<style scoped>
.sale-customers-toolbar {
  margin: 0;
}

.sale-customers-plans-inline {
  --app-filter-inline-width: 210px;
}

@media (max-width: 767px) {
  .sale-customers-plans-inline {
    width: 100%;
  }
}
</style>
